import { defineStore } from "pinia";
import axios from "axios";
// import { route } from "ziggy-js";

export const useJabatanStore = defineStore("jabatan", {
  state: () => ({
    list: [],
    loading: false,
    error: null,
  }),

  actions: {
    async fetchAll() {
      this.loading = true;
      try {
        const response = await axios.get(route("jabatan.api.index"));
        this.list = response.data;
      } catch (err) {
        this.error = err.response?.data || err;
      } finally {
        this.loading = false;
      }
    },

    async remove(id) {
      try {
        await axios.delete(route("jabatan.destroy", id));
        this.list = this.list.filter((j) => j.id !== id);
      } catch (err) {
        throw err.response?.data || err;
      }
    },
  },
});
